import {IRemoteRefreshScheduleInfo} from '../../ts/models/IRemoteRefreshScheduleInfo';
import React from 'react';
import {Messages} from '../../codegen/Localize';

import {ReactActionDialogBodyProps} from '~commonInfra/dialogs/ReactActionDialog';
import {InlineAlertType, InlineAlertWidget, TextFieldWidget} from '@tableau/widgets';

export interface EditRemoteRefreshExpectedDurationDialogProps {
  currentExpectedDurationInfo: IRemoteRefreshScheduleInfo;
}

export interface EditRemoteRefreshExpectedDurationDialogState {
  hours: string;
  minutes: string;
  errorMessage: string;
}

export type PropsForEditRemoteRefreshExpectedDurationDialogBody = ReactActionDialogBodyProps<EditRemoteRefreshExpectedDurationDialogProps, EditRemoteRefreshExpectedDurationDialogState>;


export function EditRemoteRefreshExpectedDurationDialogBody(props: PropsForEditRemoteRefreshExpectedDurationDialogBody): JSX.Element {
    const dialogPrompt = Messages.editRemoteRefreshExpectedDurationDialogPrompt();
    const setAmountTimePrompt = Messages.editRemoteRefreshExpectedDurationDialogSetAmountTime();
    const hoursPrompt = Messages.editRemoteRefreshExpectedDurationDialogHours();
    const minutesPrompt = Messages.editRemoteRefreshExpectedDurationDialogMinutes();


  return <>
      <div className="tb-remote-refresh-expected-duration-prompt tb-padded-bottom">
        <span> {dialogPrompt} </span>
      </div>
      <div className="tb-remote-refresh-expected-duration-prompt tb-padded-bottom">
        <span> {setAmountTimePrompt} </span>
      </div>
      <div className="tb-dialog-body-input-description">
        <table>
          <tr>
            <td>
              <TextFieldWidget
                testId="anext_site_password_textfield_dialog"
                label={hoursPrompt}
                value={props.dialogState.hours}
                onChange={e => {
                  props.updateDialogState({hours: e.target.value, errorMessage: ''});
                }
                }
                />
            </td>
            <td className="tb-padded">
              <TextFieldWidget
                testId="anext_site_password_textfield_dialog"
                label={minutesPrompt}
                value={props.dialogState.minutes}
                onChange={e => {
                  props.updateDialogState({minutes: e.target.value, errorMessage: ''});
                }
                }
              />
            </td>
          </tr>
        </table>
      </div>
    <div>
      {!!props.dialogState.errorMessage &&
      <InlineAlertWidget testId={'action-dialog-body-error'} type={InlineAlertType.Error}>
        {props.dialogState.errorMessage}
      </InlineAlertWidget>
      }
    </div>
  </>;
  }

  function createViewModel(hours: string, minutes: string){


  }

